<mat-progress-bar mode="determinate" [color]="color" *ngIf="Active" [value]="val"></mat-progress-bar>